import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { SelectEl } from "common/components/select";
import { ContextPanelEl } from "common/widgets/context-panel";
import { TEXT_HIGHLIGHT_THEME, TextHighlightEl } from "common/components/text-highlight";
import { ButtonEl } from "common/components/button";
import { ConfirmEl } from "common/components/confirm";
import { CreateEntityModalEl } from "common/widgets/create-entity-modal";
import { ButtonTheme } from "common/components/button/constants";
import { Placement } from "common/components/tooltip/types";
import { THEME } from "common/components/confirm/types";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section";
import { RowLabelType } from "common/query-builder/query-entry-section/types";
import { Directions } from "common/components/drop-menu/types";
import { EditorEl } from "./editor";
const UPSELL_TEXT = `When you upgrade your plan, custom properties can be created and saved to use across all reports in a project.`;
const FieldErrorTooltip = ({ errors, field }) => {
  return errors[field] ? /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-error-tooltip"
  }, errors[field]) : null;
};
export function template() {
  const {
    autocompleteOpen,
    autocompletePopup,
    currentAutocompleteLine,
    customProperty,
    errors,
    toCreate,
    toDelete,
    tooltipData
  } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-modal-wrapper"
  }, !toCreate ? /* @__PURE__ */ jsx(ModalEl, {
    sel: ".custom-property-modal",
    attrs: {
      open: this.attr(`open`),
      "grow-to-content": true
    },
    on: {
      change: this.helpers.modalStateChange
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-card-header"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-card-header-title"
  }, this.helpers.getHeaderText())), /* @__PURE__ */ jsx("form", {
    sel: ".custom-property-body",
    class: { "for-behaviors": this.helpers.isBehavioralProperty() }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-label"
  }, "Name"), /* @__PURE__ */ jsx(FieldErrorTooltip, {
    errors,
    field: "name"
  })), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section-container"
  }, /* @__PURE__ */ jsx("input", {
    sel: ".custom-property-section-input",
    on: {
      input: this.helpers.updateName
    },
    attrs: {
      autocomplete: `off`,
      elref: `nameInput`
    },
    props: {
      size: 50,
      type: `text`,
      value: this.helpers.getName()
    },
    class: {
      "custom-property-error": !!errors.name
    }
  }))), this.helpers.isPersisted() ? /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-label"
  }, "Description", /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-description-tooltip"
  }, "Optional"))), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section-container"
  }, /* @__PURE__ */ jsx("input", {
    sel: ".custom-property-section-input",
    on: {
      input: this.helpers.updateDescription
    },
    props: {
      size: 50,
      type: `text`,
      value: this.helpers.getDescription()
    }
  }))) : null, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-builder"
  }, this.helpers.isBehavioralProperty() ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-label"
  }, "Define condition")), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-query-events-section"
  }, /* @__PURE__ */ jsx(QueryEntrySectionEl, {
    attrs: {
      entries: this.helpers.getQueryEntries(),
      "enable-workspace-filter-restrictions": this.attr(`enable-workspace-filter-restrictions`),
      "hide-edit-controls": true,
      "include-custom-properties": `persisted-only`,
      "disable-delete-entry": true,
      "project-id": this.attr(`project-id`),
      "row-label-type": RowLabelType.None,
      "metrics-mode": true,
      "row-limit": 1,
      "row-types": this.helpers.getBehavioralSelectorTypes(),
      "event-aggregator-functions": this.helpers.getBehavioralAggregationMethods(),
      "property-aggregator-functions": this.helpers.getBehavioralAggregationMethods(),
      "track-name": this.attr(`track-name`),
      "user-id": this.attr(`user-id`),
      "workspace-id": this.attr(`workspace-id`)
    },
    on: {
      update: (ev) => this.helpers.handleQueryEventsSectionUpdate(ev)
    }
  }))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-flex-wrapper.custom-property-formula-flex-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-label.custom-property-formula-label"
  }, "Formula"), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-tooltip",
    on: { click: this.helpers.tooltipClicked }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` }
  }), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { "max-width": `480px`, placement: Placement.Right, clickable: `true` }
  }, "Click to view documentation")), /* @__PURE__ */ jsx(FieldErrorTooltip, {
    errors,
    field: "displayFormula"
  }), /* @__PURE__ */ jsx(SelectEl, {
    sel: ".custom-property-example-menu",
    attrs: {
      elref: `insertExample`,
      "menu-width": 160,
      options: this.helpers.getExampleOptions(),
      "selected-option": `Insert Example`,
      "disable-search": true
    },
    on: {
      change: this.helpers.handleInsertExample
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-input-area",
    class: {
      "custom-property-error": !!errors.displayFormula
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-ace-wrapper",
    key: "ace-editor"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-border"
  }), /* @__PURE__ */ jsx(EditorEl, {
    attrs: {
      "composed-properties": JSON.stringify(this.helpers.getComposedProperties()),
      "display-formula": this.helpers.getDisplayFormula(),
      "event-names": this.attr(`event-names`),
      "enable-workspace-filter-restrictions": this.attr(`enable-workspace-filter-restrictions`),
      "project-id": this.attr(`project-id`),
      "resource-type": this.helpers.getResourceType(),
      "user-id": this.attr(`user-id`),
      "workspace-id": this.attr(`workspace-id`),
      elref: `ace-editor`
    },
    on: {
      connect: this.helpers.handleEditorConnect,
      change: this.helpers.handleValueChange,
      autocompleteChange: this.helpers.handleEditorAutocompleteChange
    },
    hook: {
      insert: this.helpers.handleEditorElementInsert
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-border"
  })), autocompletePopup ? /* @__PURE__ */ jsx(ContextPanelEl, {
    attrs: {
      "tooltip-data": tooltipData,
      placement: autocompleteOpen ? Directions.Right : Directions.Left,
      "force-placement": !autocompleteOpen,
      "always-expanded": true
    },
    props: {
      tooltipPositionParentElement: autocompleteOpen ? autocompletePopup : currentAutocompleteLine
    }
  }) : null), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-info-tooltip"
  }, "Press", /* @__PURE__ */ jsx(TextHighlightEl, {
    attrs: { text: `Period (.)`, theme: TEXT_HIGHLIGHT_THEME.GENERIC, size: `medium` }
  }), "to insert a property and", /* @__PURE__ */ jsx(TextHighlightEl, {
    attrs: { text: `Control + Space`, theme: TEXT_HIGHLIGHT_THEME.GENERIC, size: `medium` }
  }), "to see a list of formula functions.")))), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-footer"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-flex-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-action-wrapper"
  }, this.helpers.isPersisted() ? /* @__PURE__ */ jsx(ButtonEl, {
    on: { click: this.helpers.setToDelete }
  }, "Delete") : this.helpers.isSavingRestricted() && !this.helpers.isBehavioralProperty() ? /* @__PURE__ */ jsx("div", {
    sel: ".upsell-button"
  }, /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Right }
  }, UPSELL_TEXT), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      icon: `share`
    },
    on: { click: this.helpers.openPricingUpsell }
  }, "Upgrade to Save")) : !this.attr(`enable-workspace-filter-restrictions`) && !this.helpers.isBehavioralProperty() ? /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      disabled: this.helpers.isSavingDisabled()
    },
    on: { click: () => this.helpers.applyProperty(true) }
  }, "Save") : null)), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".custom-property-button.custom-property-cancel-button",
    attrs: { theme: ButtonTheme.Tertiary },
    on: { click: this.helpers.closeModal }
  }, "Cancel"), this.helpers.isEdit() && this.helpers.isPersisted() ? this.helpers.isSavingRestricted() ? /* @__PURE__ */ jsx("div", {
    sel: ".upsell-button"
  }, /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Left }
  }, UPSELL_TEXT), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      icon: `share`
    },
    on: { click: this.helpers.openPricingUpsell }
  }, "Upgrade to Update")) : /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".custom-property-button.custom-property-save-button",
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: this.helpers.isSavingDisabled()
    },
    on: { click: () => this.helpers.applyProperty(false) }
  }, "Update") : /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".custom-property-button.custom-property-save-button",
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: this.helpers.isSavingDisabled(),
      elref: `applyButton`
    },
    on: { click: () => this.helpers.applyProperty(false) }
  }, "Apply")), /* @__PURE__ */ jsx(ConfirmEl, {
    attrs: { theme: THEME.DELETE, open: !!toDelete, closeable: true },
    on: {
      change: (ev) => this.helpers.handleDeleteConfirmChange(ev.detail.state),
      submit: (ev) => {
        if (ev.detail.action === `confirm`) {
          this.helpers.deleteProperty();
        }
      }
    }
  }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-title"
  }, "Delete Custom Property"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-description"
  }, 'Are you sure you want to delete "', customProperty.name, '"? This action is permanent and cannot be undone.')))) : /* @__PURE__ */ jsx(CreateEntityModalEl, {
    attrs: this.helpers.buildCreateEntityModalAttrs(),
    on: {
      save: this.helpers.handleCreate,
      cancel: this.helpers.handleCancelCreate,
      saveAndShare: this.helpers.handleCreate
    },
    props: {
      existingEntityNames: this.helpers.getPersistedCustomPropertyNames()
    }
  }));
}
